import { useLang } from "@/context/LanguageContext";
import { Medal, Briefcase } from "lucide-react";

const PHOTOS = {
  carlos: "https://customer-assets.emergentagent.com/job_elite-sports-hub-7/artifacts/f6umwhgr_e37c85aa-f407-4e9d-8ac9-888466a4732b_33.jpg",
  sebastian: "https://customer-assets.emergentagent.com/job_elite-sports-hub-7/artifacts/grd8ilgq_2bf3ea13-0f48-4635-bda6-faede270b090_33.jpg",
};

export default function Team() {
  const { t } = useLang();

  const members = [
    { key: "carlos", data: t.team.carlos, icon: Medal, photo: PHOTOS.carlos },
    { key: "sebastian", data: t.team.sebastian, icon: Briefcase, photo: PHOTOS.sebastian },
  ];

  return (
    <section
      id="team"
      data-testid="team-section"
      className="py-24 sm:py-32 bg-[#111111]"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-[2px] bg-[#FF3B30]" />
          <span className="text-xs uppercase tracking-[0.3em] text-[#A3A3A3] font-body">
            {t.team.label}
          </span>
        </div>

        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight text-white mb-16">
          {t.team.title}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl">
          {members.map((m, i) => (
            <div
              key={m.key}
              data-testid={`team-card-${m.key}`}
              className="group bg-[#0A0A0A] border border-[#262626] overflow-hidden hover:border-[#FF3B30] transition-all hover:-translate-y-1 animate-fade-in"
              style={{ animationDelay: `${i * 0.15}s` }}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={m.photo}
                  alt={m.data.name}
                  className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-8">
                <m.icon className="w-8 h-8 text-[#FF3B30] mb-4 transition-transform group-hover:scale-110" />
                <h3 className="font-heading text-2xl uppercase tracking-wider text-white mb-1">
                  {m.data.name}
                </h3>
                <p className="text-xs uppercase tracking-[0.2em] text-[#FF3B30] font-body mb-4">
                  {m.data.role}
                </p>
                <div className="w-8 h-[2px] bg-[#262626] mb-4 transition-all group-hover:bg-[#FF3B30] group-hover:w-12" />
                <p className="text-sm text-[#A3A3A3] font-body leading-relaxed">
                  {m.data.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
